export default __webpack_public_path__ + "static/media/FNShop.bedb960b.png";